import FeedItemViewContainer from './containers/FeedItemViewContainer'

export default FeedItemViewContainer
